import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import styles from "./WorkCard.module.css";

export const workGrounds = [
  "#d1dfe3",
  "#e1dccb",
  "#d8e0d1",
  "#ddd4e4",
  "#c7dcdb",
  "#e7d7cf",
];
export default function WorkCard({
  item,
  index = 0,
  kind = "client",
  priority = false,
}) {
  const { t, i18n } = useTranslation(["studio", "projects"]);
  const prefix = i18n.language?.startsWith("es") ? "/es" : "";
  const name =
    kind === "product"
      ? t(`items.${item.slug}.name`, { ns: "projects" })
      : item.name;
  return (
    <article className={styles.card} data-work-card={kind}>
      <Link
        to={`${prefix}/projects/${item.slug}`}
        className={styles.link}
        aria-label={`${t("workIndex.explore")}: ${name}`}
      >
        <div
          className={styles.mount}
          style={{ "--mount": workGrounds[index % workGrounds.length] }}
        >
          <img
            src={`/images/studio/work/${item.slug}.webp`}
            alt={`${name} — ${kind === "client" ? "Shopify" : t(`items.${item.slug}.tagline`, { ns: "projects" })}`}
            width="1200"
            height="675"
            loading={priority ? "eager" : "lazy"}
          />
          <span className={styles.visit}>
            <ArrowUpRight size={23} strokeWidth={1.5} />
          </span>
        </div>
        <div className={styles.caption}>
          <h3>{name}</h3>
          <span>
            {kind === "client"
              ? "Shopify"
              : t(`status.${item.status}`, { ns: "projects" })}
          </span>
        </div>
        {kind === "product" && (
          <p className={styles.description}>
            {t(`items.${item.slug}.tagline`, { ns: "projects" })}
          </p>
        )}
      </Link>
    </article>
  );
}
